import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';

import type { Attachment } from '../lib/useFileAttachments';

interface Props {
  attachments: Attachment[];
  onRemove: (id: string) => void;
}

const AttachmentList = ({ attachments, onRemove }: Props) => {
  if (!attachments.length) return null;
  return (
    <div className="flex flex-wrap gap-2 px-3 pb-2 pt-1">
      {attachments.map((attachment) => (
        <div
          key={attachment.id}
          className="flex max-w-xs items-center gap-2 rounded-lg border border-border-subtle bg-bg-surface-alt px-2 py-1 text-xs text-text-default"
        >
          <span className="truncate">{attachment.file.name}</span>
          <Button
            size="icon-xs"
            variant="ghost"
            type="button"
            onClick={() => onRemove(attachment.id)}
            aria-label={`Quitar ${attachment.file.name}`}
          >
            <X className="size-3" />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default AttachmentList;
